<template>
  <tr :class="{'reservation':true, 'shrink':shrink, [resStatus(rsvp)]:true}" v-if="!isMobile">
    <td class="rc-1">
      <input type="checkbox"
      :value="{id: rsvp.id, isPackage: rsvp.isPackage, status: rsvp.statusClass}"
      v-model="checkedReservations" />
    </td>
    <td class="map-button rc-2">
      <a @click="showOnMap" href="javascript:;" :class="{disabled: loadingRsvpId !== null, selected: rsvpInMap.id === rsvp.id}">
        <i v-show="loadingRsvpId !== rsvp.id" class="fas fa-map-marker-alt"></i>
        <i class="fas fa-spinner fa-spin fa-fw" v-show="loadingRsvpId === rsvp.id"></i>
      </a>
    </td>
    <td class="package-icon no-padding rc-3">
      <i class="fas fa-cube fa-fw fa-lg" v-if="rsvp.isPackage"></i>
      <div class="tool-tip-box">
        <i class="fas fa-route fa-fw fa-lg" v-if="rsvp.hasExtraStop"></i>
        <span>With extra stop</span>
      </div>
      <div class="tool-tip-box">
        <img v-if="rsvp.isOptinShared" src="../../assets/img/shared-ride-blue.png" class="optin-icon" />
        <span>Opted in to a shared service</span>
      </div>
    </td>
    <td class="bold rc-4">
      <a :href="'/#/reservation/' + rsvp.id" target="_blank" v-if="!rsvp.isPackage">{{ rsvp.id }}</a>
      <a :href="'/#/package/' + rsvp.id" target="_blank" v-else>{{ rsvp.id }}</a>
    </td>
    <td class="rc-5" v-show="!shrink">
      <div v-if="rsvp.pendingOffer && rsvp.pendingOffer.show">
        <span class="status pending-offer">Pending Offer</span>
        <i class="fas fa-spinner fa-spin" v-if="checkingDriver"></i>
        <b class="timer" v-else>{{timer}}s</b>
      </div>
      <div v-else>
        <span :class="['status', rsvp.statusClass, resStatus(rsvp)]">{{ rsvp.status }}</span>
        <span v-if="acceptedRTGStatus(rsvp.status) && !rsvp.isPackage && rsvp.pickup.geofenceType === 'airport' && !rsvp.isMtech" class="rtg" @click="showRTG(rsvp.id)">RTG</span>
        <span class="notes" @click="showNotes(rsvp.notes)" v-if="rsvp.notes != null && rsvp.notes.length"><i class="fas fa-sticky-note"></i> NOTES</span>
      </div>
    </td>
    <td class="rc-6" v-show="!shrink">{{ rsvp.pickupTime }}</td>
    <td class="rc-7" v-show="!shrink">{{ getAddress(rsvp.pickup) }}</td>
    <td class="rc-8" v-show="!shrink">
      <span v-if="rsvp.isCharter">--</span>
      <span v-else>
        {{ rsvp.dropoffTime }}<br/>
        <b v-if="!!rsvp.hoursLeft">({{ rsvp.hoursLeft }})</b>
      </span>
    </td>
    <td class="rc-8" v-show="!shrink">
      <span v-if="rsvp.isCharter">--</span>
      <span v-else>{{ getAddress(rsvp.dropoff) }}</span>
    </td>
    <td class="bold rc-9" v-if="!isShort && !shrink">
      <div v-if="!rsvp.isPackage">
        <i class="fas fa-address-card fa-lg fa-fw" v-show="rsvp.guest !== null"></i>
        <a :href="'/#/consumer/' + rsvp.customer.id" target="_blank">
          <span v-show="rsvp.guest !== null"> {{ getName(rsvp.guest) }} </span>
          <span v-show="rsvp.guest === null">{{ getName(rsvp.customer) }}</span>
        </a>
        <br/>
        <a href="javascript:;" @click="callPhone(rsvp.customer)" v-if="rsvp.guest === null">
          {{ rsvp.customer.phone }}
        </a>
        <span v-else>
          <a v-if="rsvp.guest !== null && rsvp.guest.phone !== ''"
            href="javascript:;" @click="callPhone(rsvp.guest)">
            {{ rsvp.guest.phone }}
          </a>
        </span>
      </div>
      <div v-else>
        <i class="fas fa-address-card fa-fw fa-lg" v-show="rsvp.legs[0].guest !== null"></i>
        <a :href="'/#/consumer/' + rsvp.legs[0].customer.id" target="_blank">
          <span v-show="rsvp.legs[0].guest !== null"> {{ getName(rsvp.legs[0].guest) }} </span>
          <span v-show="rsvp.legs[0].guest === null">{{ getName(rsvp.legs[0].customer) }}</span>
        </a>
        <br/>
        <a href="javascript:;" @click="callPhone(rsvp.legs[0].customer)"
           v-if="rsvp.legs[0].guest === null">
          {{ rsvp.legs[0].customer.phone }}
        </a>
        <span v-else>
          <a v-if="rsvp.legs[0].guest !== null && rsvp.legs[0].guest.phone !== ''"
            href="javascript:;" @click="callPhone(rsvp.legs[0].guest)">
            {{ rsvp.legs[0].guest.phone }}
          </a>
        </span>
      </div>
    </td>
    <td v-if="!isShort && !shrink" class="rc-10">
      <span v-if="rsvp.isPackage">${{ (rsvp.fare + rsvp.airportFee).toFixed(2) }}</span>
      <span v-else>${{ rsvp.fare.toFixed(2) }}</span>
    </td>
    <td class="bold rc-11" v-if="!isShort && !shrink">
      <a :href="'/#/provider/' + rsvp.driver.id" target="_blank"
         v-if="rsvp.driver !== null">
        {{ getName(rsvp.driver) }}
      </a>
      <span v-else>N/A</span>
    </td>
    <td class="rc-12" v-show="!shrink && showDriverPayment">
      ${{(rsvp.driverPayment.base + rsvp.driverPayment.bonus + rsvp.driverPayment.tip + rsvp.driverPayment.gasFee + rsvp.driverPayment.pickupFee).toFixed(2)}}
    </td>
    <td class="rc-13" v-show="!shrink">
      <span v-bind:class="'service-type ' + rsvp.serviceClass" v-if="useOldQuatation">{{ rsvp.serviceLabel }}</span>
      <span class="service-type" :style="{background: rsvp.serviceType.color}" v-else>{{ rsvp.serviceType.label }}</span>
    </td>
    <td v-if="!isShort && !shrink" class="rc-14">
      <div v-if="rsvp.pickup.geofenceType === 'airport'">
        <span v-if="rsvp.meetAndGreet">Meet &amp; Greet</span>
        <span v-else>Curbside</span>
      </div>
      <span v-else>N/A</span>
    </td>
    <td class="image rc-15" v-show="!shrink">
      <img src="/assets/img/arrival.png" v-if="rsvp.pickup.geofenceType === 'airport' && rsvp.flight" />
      <img src="/assets/img/departure.png" v-if="rsvp.dropoff.geofenceType === 'airport' && rsvp.flight" />
    </td>
    <td class="bold rc-16" v-show="!shrink">
      <span v-if="rsvp.flight !== null">
        <a href="javascript:;" @click="showFlightInfo"
          v-if="rsvp.statusClass !== 'complete' && rsvp.statusClass !== 'completed' && rsvp.statusClass !== 'canceled'">
        {{ rsvp.flight }}
        </a>
        <span v-else>{{ rsvp.flight }}</span>
      </span>
      <span v-else>N/A</span>
      <span v-if="flightStatus !== null" v-bind:class="'flight-status ' + flightStatus.class">{{ flightStatus.label }}</span>
    </td>
    <td v-if="!isShort && !shrink" class="rc-17">
      <div v-if="rsvp.ada === null || (rsvp.ada.serviceDog === 0 && rsvp.ada.wheelChairLift === 0)">N/A</div>
      <div v-else>
        <span v-show="rsvp.ada.serviceDog === 1"><svg-dog></svg-dog></span>
        <span v-show="rsvp.ada.wheelChairLift === 1"><svg-wheelchair></svg-wheelchair></span>
      </div>
    </td>
    <td class="rc-18" v-show="!shrink">{{ rsvp.pax }}</td>
    <td class="rc-19" v-show="!shrink">{{ rsvp.luggage }}/{{ rsvp.stops }}</td>
  </tr>
  <div v-else class="table-card">
    <div class="row-1">
      <div>
        <input type="checkbox"
        :value="{id: rsvp.id, isPackage: rsvp.isPackage, status: rsvp.statusClass}"
        v-model="checkedReservations" />
          <i class="fas fa-cube fa-fw fa-lg" v-if="rsvp.isPackage"></i> 
          <a :href="'/#/reservation/' + rsvp.id" target="_blank" v-if="!rsvp.isPackage">{{ rsvp.id }}</a>
          <a :href="'/#/package/' + rsvp.id" target="_blank" v-else>{{ rsvp.id }}</a>
        <span v-bind:class="'status ' + rsvp.statusClass + ' ' + resStatus(rsvp)">{{ rsvp.status }}</span>
      </div>
      <div class="map-button">
        <a @click="showOnMap" href="javascript:;"
         v-bind:class="{
           disabled: loadingRsvpId !== null,
           selected: rsvpInMap.id === rsvp.id
         }">
        <i v-show="loadingRsvpId !== rsvp.id"
          class="fas fa-map-marker-alt"></i>
        <i class="fas fa-spinner fa-spin fa-fw" v-show="loadingRsvpId === rsvp.id"></i>
      </a>
      </div>
    </div>
    <div class="row-2">
        <div>
          <span v-bind:class="'service-type ' + rsvp.serviceClass" v-if="useOldQuatation">{{ rsvp.serviceLabel }}</span>
          <span class="service-type" :style="{background: rsvp.serviceType.color}" v-else>{{ rsvp.serviceType.label }}</span>
        </div>
        <div class="image">
          <img src="/assets/img/arrival.png" v-if="rsvp.pickup.geofenceType === 'airport' && rsvp.flight" />
          <img src="/assets/img/departure.png" v-if="rsvp.dropoff.geofenceType === 'airport' && rsvp.flight" />
        </div>
        <div>
          <span v-if="rsvp.flight !== null">
          <a href="javascript:;" @click="showFlightInfo"
            v-if="rsvp.statusClass !== 'complete' && rsvp.statusClass !== 'completed' && rsvp.statusClass !== 'canceled'">
          {{ rsvp.flight }}
          </a>
          <span v-else>{{ rsvp.flight }}</span>
          </span>
          <span v-else>N/A</span>
          <span v-if="flightStatus !== null" v-bind:class="'flight-status ' + flightStatus.class">{{ flightStatus.label }}</span>
        </div>
    </div>
    <div>
      <span>Pickup Time: {{ rsvp.pickupTime }}</span>
    </div>
    <div class="row-4">
      <div class="pickup">
        <i class="fas fa-map-marker-alt icon"></i>
        {{ getAddress(rsvp.pickup) }}
      </div>
    </div>
    <div class="row-5">
      <div class="dropoff">
        <i class="fas fa-location-arrow icon"></i>
        <span v-if="rsvp.isCharter">--</span>
        <span v-else>{{ getAddress(rsvp.dropoff) }}</span>
      </div>
    </div>
    <div class="row-3">
      <div class="clock">
        Dropoff Time:
        {{ rsvp.dropoffTime }}
        <b v-if="!!rsvp.hoursLeft">({{ rsvp.hoursLeft }})</b>
      </div>
    </div>

    <div class="toggle-div">
      <div class="row-7">
        <div v-if="!isCollapsible">
          <span><i class="fas fa-user-friends icon"></i>{{ rsvp.pax }}</span>
          <span><i class="fas fa-suitcase icon"></i>{{ rsvp.luggage }}</span>
          <span><i class="fas fa-hourglass-end icon"></i>{{ rsvp.stops }}</span>
          <div class="actions">
            <span v-if="acceptedRTGStatus(rsvp.status) && !rsvp.isPackage && rsvp.pickup.geofenceType === 'airport'" class="rtg" @click="showRTG(rsvp.id)">RTG</span>
            <span v-if="rsvp.notes != null && rsvp.notes.length > 0" class="notes" @click="showNotes(rsvp.notes)"><i class="fas fa-sticky-note"></i> NOTES</span>
          </div>
        </div>
        <div v-else>
          <div>Pax: <strong>{{rsvp.pax}}</strong></div>
          <div>Luggage: <strong>{{rsvp.luggage}}</strong></div>
          <div>Stops: <strong>{{rsvp.stops}}</strong></div>
        </div>
      </div>
      <div class="toggle" @click="isCollapsible = !isCollapsible">
        <span v-if="!isCollapsible">
          <i class="fas fa-plus-circle"></i>
        </span>
        <span v-else>
          <i class="fas fa-minus-circle"></i>
        </span>
      </div>
    </div>

    <transition name="slide-down">
      <div v-show="isCollapsible" class="see-more">
        <div>
          <div v-if="!rsvp.isPackage">
            Customer Name:
            <strong>
              <i class="fas fa-address-card fa-lg fa-fw" v-show="rsvp.guest !== null"></i>
              <a :href="'/#/consumer/' + rsvp.customer.id" target="_blank">
                <span v-show="rsvp.guest !== null"> {{ getName(rsvp.guest) }} </span>
                <span v-show="rsvp.guest === null">{{ getName(rsvp.customer) }}</span>
              </a>
            </strong>
            <br/>
            Customer Phone:
            <a href="javascript:;" @click="callPhone(rsvp.customer)" v-if="rsvp.guest === null">
              {{ rsvp.customer.phone }}
            </a>
            <span v-else>
              <a v-if="rsvp.guest !== null && rsvp.guest.phone !== ''"
                href="javascript:;" @click="callPhone(rsvp.guest)">
                {{ rsvp.guest.phone }}
              </a>
            </span>
          </div>
        </div>

        <div>
          Fare Amount: <strong>
            <span v-if="rsvp.isPackage">${{ (rsvp.fare + rsvp.airportFee).toFixed(2) }}</span>
            <span v-else>${{ rsvp.fare.toFixed(2) }}</span>
          </strong>
        </div>

        <div>
          Driver: <strong>
            <a :href="'/#/provider/' + rsvp.driver.id" target="_blank"
              v-if="rsvp.driver !== null">
              {{ getName(rsvp.driver) }}
            </a>
            <span v-else>N/A</span>
          </strong>
        </div>

        <div class="row-6" v-show="showDriverPayment">
          <span>
          Driver Payment: <b>${{(rsvp.driverPayment.base +
                rsvp.driverPayment.bonus +
                rsvp.driverPayment.tip +
                rsvp.driverPayment.pickupFee).toFixed(2)}}</b>
          </span>
        </div>

        <div>
          Pickup Type: <strong>
            <div v-if="rsvp.pickup.geofenceType === 'airport'">
              <span v-if="rsvp.meetAndGreet">Meet &amp; Greet</span>
              <span v-else>Curbside</span>
            </div>
            <span v-else>N/A</span>
          </strong>
        </div>

        <div>
          ADA: <strong>
            <span v-if="rsvp.ada === null || (rsvp.ada.serviceDog === 0 && rsvp.ada.wheelChairLift === 0)">N/A</span>
            <span v-else>
              <span v-show="rsvp.ada.serviceDog === 1" class="svg-icon"><svg-dog></svg-dog></span>
              <span v-show="rsvp.ada.wheelChairLift === 1" class="svg-icon"><svg-wheelchair></svg-wheelchair></span>
            </span>
          </strong>
        </div>

      <div class="row-8">
        <div class="actions">
          <span v-if="acceptedRTGStatus(rsvp.status) && !rsvp.isPackage && rsvp.pickup.geofenceType === 'airport'" class="rtg" @click="showRTG(rsvp.id)">RTG</span>
          <span v-if="rsvp.notes != null && rsvp.notes.length > 0" class="notes" @click="showNotes(rsvp.notes)"><i class="fas fa-sticky-note"></i> NOTES</span>
        </div>
      </div>
      </div>
    </transition>
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment'
import SvgDog from '@/components/Partials/SVG/ServiceDog'
import SvgWheelchair from '@/components/Partials/SVG/Wheelchair'
import ApiFlightInfo from '@/modules/api/flight-info'
import featureToggle from '@/modules/api/featureToggle'

export default {
  name: 'reservation-row',
  props: ['rsvp', 'isShort', 'shrink', 'isMobile'],
  data () {
    return {
      flightStatus: null,
      timerDelay: '',
      isCollapsible: false,
      timer: 20,
      checkingDriver: false
    }
  },
  components: {
    SvgDog, SvgWheelchair
  },
  computed: {
    checkedReservations: {
      get () { return this.$store.state.dispatch.checkedReservations },
      set (value) { this.$store.commit('dispatch/updateCheckedReservations', value) }
    },
    loadingRsvpId () { return this.$store.state.dispatch.loadingRsvpId },
    rsvpInMap () { return this.$store.state.dispatch.rsvpInMap },
    useOldQuatation () { return CONFIG.useOldQuatation },
    showDriverPayment () { return this.$settings.get('DispatchShowDriverPayment') }
  },
  methods: {
    showFlightInfo () {
      let self = this
      ApiFlightInfo.loadFlightInfo(self, self.rsvp, r => {
        if (r.error) {
          self.flightStatus = { label: 'On Time', class: 'ontime' }
          return
        }
        self.flightStatus = self.translateFlightStatus(r.status)
      })
    },
    getFlightStatus () {
      let self = this
      if (self.rsvp.airlineCode === null ||
          self.rsvp.statusClass === 'complete' ||
          self.rsvp.statusClass === 'completed' ||
          self.rsvp.statusClass === 'canceled') {
        self.flightStatus = null
        return
      }

      let date = moment(self.rsvp.pickupTime, 'MM/DD/YYYY ' + featureToggle.timeFormat(self, false))
      let airlineDate = encodeURIComponent(date.format('YYYY-MM-DD'))
      let airlineTime = encodeURIComponent(date.format('HH:mm:ss'))
      let flightNumber = self.rsvp.flightNumber || self.rsvp.dropoffFlightNumber
      let isDeparture = '&departure=0'
      if ((self.rsvp.airline === null || self.rsvp.airline === '') &&
        (self.rsvp.dropoffAirline !== null && self.rsvp.dropoffAirline !== '')
      ) {
        isDeparture = '&departure=1'
      }
      let url = '/availability/flights/' +
                  self.rsvp.airlineCode + flightNumber +
                  '?date=' + airlineDate +
                  '&time=' + airlineTime +
                  '&airport=' + self.rsvp.airportCode +
                  isDeparture
      self.$sdk.get(url, {}, r => {
        if (r.error) {
          self.flightStatus = { label: 'On Time', class: 'ontime' }
          return
        }
        self.flightStatus = self.translateFlightStatus(r.status)
      })
    },
    translateFlightStatus (status) {
      switch (status) {
        case 'Scheduled': return { label: 'On Time', class: 'ontime' }
        case 'Proposed': return { label: 'On Time', class: 'ontime' }
        case 'OutGate': return { label: 'On Time', class: 'ontime' }
        case 'InAir': return { label: 'On Air', class: 'onair' }
        case 'Landed': return { label: 'Arrived', class: 'arrived' }
        case 'InGate': return { label: 'Arrived', class: 'arrived' }
        case 'Expected': return { label: 'On Time', class: 'ontime' }
        case 'NoTakeOffInfo': return { label: 'On Time', class: 'ontime' }
        case 'Delayed': return { label: 'Delayed', class: 'delayed' }
        case 'Cancelled': return { label: 'Cancelled', class: 'cancelled' }
        case 'Unknown': return { label: 'On Time', class: 'ontime' }
        case 'PastFlight': return { label: 'Arrived', class: 'arrived' }
        case 'Original' : return { label: 'On Time', class: 'ontime' }
      }
      return { label: 'On Time', class: 'ontime' }
    },
    showOnMap () {
      let self = this

      if (self.rsvpInMap.id === self.rsvp.id) {
        // remove from the map
        self.$store.commit('dispatch/removeRsvpInMap')
        self.$store.commit('dispatch/clearDriverPopup')
        if (self.rsvp.driver !== null) {
          self.$store.commit('dispatch/removeDriverInMap', self.rsvp.driver)
        }
        return
      }

      if (self.rsvpInMap.id !== null && self.rsvpInMap.driver !== null) {
        self.$store.commit('dispatch/removeDriverInMap', self.rsvpInMap.driver)
      }
      self.$store.commit('dispatch/setRsvpInMap', self.rsvp)
    },
    getAddress (location) {
      if (location.geofenceType === 'airport' &&
          location.geofenceName !== '') {
        let result = location.geofenceName
        if (location.terminal && location.terminal !== '' && location.terminal !== 'undefined') {
          result += ' - Terminal ' + location.terminal
        }
        return result
      }
      return location.title

      // let address = ''
      // if (location.address2 && location.address2 !== '' && location.address2 !== 'undefined') {
      //   address = address + location.address2 + ' '
      // }
      // if (location.address1) {
      //   address = address + location.address1 + ', '
      // }
      // if (location.city) {
      //   address = address + location.city + ' '
      // }
      // if (location.state) {
      //   address = address + location.state + ' '
      // }
      // if (location.zip) {
      //   address = address + location.zip
      // }

      // return address
    },
    getName (contact) {
      if (contact === null) {
        return 'N/A'
      }
      return contact.firstName + ' ' + contact.lastName
    },
    callPhone (customer) {
      let self = this
      self.$plugins.phone.startCall(self, {
        phone: customer.phone,
        name: customer.firstName + ' ' + customer.lastName
      })
    },
    resStatus (rsvp) {
      if (rsvp.status === 'DISPATCHED') {
        if (['ontheway', 'arrived'].indexOf(rsvp.resStatus) > -1) { return 'on-time' }

        let pickupTime = moment(rsvp.pickupTime, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
        let pickupTime1 = parseInt(pickupTime.clone().subtract(this.$settings.get('DispatchLateCriticalMins'), 'minutes').format('X'))
        let pickupTime115 = parseInt(pickupTime.clone().subtract(this.$settings.get('DispatchLateWarningMins'), 'minutes').format('X'))
        let currentTime = parseInt(moment().format('X'))
        if (rsvp.isPackage && rsvp.rsvps.length) {
          let isOnTheWay = false
          rsvp.rsvps.forEach(_rsvp => {
            if (_rsvp.resStatus === 'ontheway') { isOnTheWay = true }
          })
          if (isOnTheWay) { return 'on-time' }
        }
        if (pickupTime1 <= currentTime) { return 'very-late' }
        if (pickupTime115 <= currentTime) { return 'late' }
        if (rsvp.resStatus === 'upcoming') { return 'accepted' }
      }

      // if (rsvp.status === 'UPCOMING') {
      //   let pickupTime = moment(rsvp.pickupTime, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
      //   let pickupTime1 = parseInt(pickupTime.clone().subtract(this.$settings.get('DispatchCriticalMins'), 'minutes').format('X'))
      //   let pickupTime115 = parseInt(pickupTime.clone().subtract(this.$settings.get('DispatchWarningMins'), 'minutes').format('X'))
      //   let currentTime = parseInt(moment().format('X'))
      //   if (pickupTime1 <= currentTime) { return 'no-driver-urgent' }
      //   if (pickupTime115 <= currentTime) { return 'no-driver' }
      // }
      return ''
    },
    runTimer () {
      let self = this
      let rsvp = self.rsvp
      let pickupTime = moment(rsvp.pickupTime, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
      let currentTime = parseInt(moment().format('X'))

      if (rsvp.status === 'DISPATCHED') {
        let pickupTime1 = parseInt(pickupTime.clone().subtract(this.$settings.get('DispatchLateCriticalMins'), 'minutes').format('X'))
        let pickupTime115 = parseInt(pickupTime.clone().subtract(this.$settings.get('DispatchLateWarningMins'), 'minutes').format('X'))
        if (pickupTime1 <= currentTime || pickupTime115 <= currentTime) {
          self.$forceUpdate()
          // return
        }
      }

      // if (rsvp.status === 'UPCOMING') {
      //   let pickupTime1 = parseInt(pickupTime.clone().subtract(this.$settings.get('DispatchCriticalMins'), 'minutes').format('X'))
      //   let pickupTime115 = parseInt(pickupTime.clone().subtract(this.$settings.get('DispatchWarningMins'), 'minutes').format('X'))
      //
      //   if (pickupTime1 <= currentTime || pickupTime115 <= currentTime) {
      //     self.$forceUpdate()
      //     // return
      //   }
      // }

      let index = self.$store.state.dispatch.rsvpInTable.findIndex(x => x.id === rsvp.id)
      if (self.timerDelay && index < 0) {
        clearTimeout(self.timerDelay)
      }
      self.timerDelay = setTimeout(function () {
        self.runTimer()
      }, 5000)
    },
    showRTG (id) {
      this.$store.commit('dispatch/setReadyToGoID', id)
      this.$store.commit('dispatch/setReadyToGoShow', true)
    },
    showNotes(notes) {
      this.$store.commit('dispatch/setNotesMessage', notes)
      this.$store.commit('dispatch/setNotesShow', true)
    },
    acceptedRTGStatus (status) { return ['UPCOMING', 'REQUIRES DISPATCH', 'DISPATCHED'].indexOf(status) > -1 },
    startPendingOfferTimer () {
      let self = this
      if (self.timer < 0) {
        self.checkingDriver = true
        self.$sdk.get(`/admin/rsvp/${self.rsvp.id}`, {
          token: self.$store.state.session.sessionToken
        }, r => {
          self.checkingDriver = false
          if (!r.error) {
            let statusClass = r.dispatchStatus
            let status = r.dispatchStatus.toUpperCase()
            if (statusClass === 'requires_dispatch') {
              statusClass = 'requires-dispatch'
              status = 'REQUIRES DISPATCH'
            }
            if (statusClass === 'autodispatch') {
              statusClass = 'auto-dispatch'
              status = 'AUTO DISPATCH'
            }
            if (statusClass === 'complete') {
              status = 'COMPLETED'
            }
            if (statusClass === 'ready') {
              status = 'READY TO GO'
            }
            this.$store.commit('dispatch/updateRsvpStatus', {
              id: this.rsvp.id,
              status: status,
              statusClass: statusClass,
              resStatus: r.status
            })
          }
          this.$store.commit('dispatch/setPendingOffer', {
            id: this.rsvp.id,
            show: false,
            timer: 0
          })
        })
        return
      }
      setTimeout(() => {
        self.timer--
        self.startPendingOfferTimer()
      }, 1000)
    }
  },
  watch: {
    rsvp (value) {
      // this.getFlightStatus()
    },
    'rsvp.pendingOffer' (val) {
      this.timer = val.timer
      if (this.timer) this.startPendingOfferTimer()
    }
  },
  mounted () {
    let self = this
    // self.getFlightStatus()
    self.runTimer()
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_status';
@import '../../assets/scss/_service-types';
.reservation{
  background-color: #fff;
  border: 1px solid rgba(0,0,0,0.3);

  & td{
    padding: 10px 5px;
    text-align: center;
    font-size: 12px;
    margin-bottom: 5px;

    &.package-icon{
      padding: 10px 0 10px 10px;
      color: #26D97A;

      .fa-route{
        color: #555;
      }
      .tool-tip-box{
        position: relative;

        span{
          display: none;
          position: absolute;
          bottom: calc(100% + 6px);
          left: -5px;
          font-size: 13px;
          border: 1px solid #888;
          background: #fafafa;
          color: #333;
          padding: 3px 5px;
          width: 120px;
          text-align: center;
        }
        i:hover + span, img:hover + span{
          display: block;
        }
      }
    }

    &.map-button{
      padding: 10px 0;

      & a{
        color: #fff;
        background-color: #aaa;
        width: 30px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        display: inline-block;
        border-radius: 30px;
        transition: all 250ms;

        & i {line-height: inherit;}

        &.selected{
          background-color: #26D97A;
        }
        &.disabled{
          pointer-events: none;
          opacity: 0.5;
          background-color: #bbb;
        }
      }
    }

    & input{
      margin-top: 0;
      width: 13px;
    }

    & img{ min-width: 30px; max-width: 30px; }
  }

  & .bold{ font-weight: 700; }

  & .flight-status{ padding: 1px 4px; font-size: 10px; }

  &.shrink{
    display: block;
    .rc-1{
      width: 40px!important;
      padding-left: 15px;
    }
    .rc-2{ width: 40px!important; }
    .rc-3{ width: 40px!important; }
    .rc-4{ width: 65px!important; }
  }
}

.fa-address-card { color: #555; }

.status{
  &.accepted{ background: #777; }
  &.on-time{ background: #26d97a; }
  &.late{ background: #dc9831; }
  &.very-late{ background: #e62e2e; }
  &.pending-offer{
    background: #ef7a0b;
    line-height: 12px;
    position: relative;
    overflow: hidden;
    box-shadow: 0 0 2px 1px rgba(0,0,0, .2);

    &:after {
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: linear-gradient(
        130deg,
        rgba(227, 227, 227, 0) 0%,
        rgba(227, 227, 227, 0) 40%,
        rgba(255, 255, 255, 0.7) 50%,
        rgba(227, 227, 227, 0) 60%,
        rgba(227, 227, 227, 0) 100%
      );
      animation: gradient-animation_2 1.2s linear infinite;
    }
  }
}
@keyframes gradient-animation_2 {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}
.timer{
  display: inline-block;
}

tr.reservation{
  &.no-driver{ animation: no-driver 1.5s ease infinite; }
  &.no-driver-urgent{ animation: no-driver-urgent 1s ease infinite; }
}

@keyframes no-driver {
  0% {
    box-shadow: inset 0 0 0 #fff;
    background: #fff;
  }
  40% {
    box-shadow: inset 0 0 20px #ff8252;
    background: rgba(255,135,0, .1);
  }
  100% {
    box-shadow: inset 0 0 0 #fff;
    background: #fff;
  }
}
@keyframes no-driver-urgent {
  0% {
    box-shadow: inset 0 0 0 #fff;
    background: #fff;
  }
  40% {
    box-shadow: inset 0 0 10px 1px #f20d0d;
    background: rgba(255,0,0, .1);
  }
  100% {
    box-shadow: inset 0 0 0 #fff;
    background: #fff;
  }
}

.rtg{
  color: #fff;
  line-height:1;
  display:block;
  font-size:12px;
  font-weight: 600;
  margin: 2px 4px;
  cursor: pointer;
  padding: 3px 15px;
  border-radius: 4px;
  background: #2586f3;
  letter-spacing: 1px;
  border-bottom: 3px solid #084991;
}

.notes{
  color: #fff;
  line-height:1;
  display:inline-block;
  font-size:11px;
  font-weight: 600;
  margin: 2px 4px;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  background: #f44336;
  letter-spacing: 1px;
  border-bottom: 3px solid #863a34;
}

@media only screen and (max-width: 430px) {
  .table-card {
    border: 1px solid #ccc;
    margin: 10px;
    margin-bottom: 15px;
    padding: 10px;
    border-bottom: 5px solid #aaa9;
    border-radius: 10px;
    font-size: 13px;

    a {
      font-weight: 900;
    }

    i {
      color: #0d79f2;
    }

    > div {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      margin-bottom: 3px;

      &.see-more {
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
      }

      .svg-icon svg {
        height: 20px;
        width: 20px;
      }
    }

    .toggle-div {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      .toggle {
        font-size: 18px;
        color: #0e79f2;
      }
    }

    .row-1 {
      i {
        color: #26D97A;
      }
      input {
        display: inline-block;
        margin: 0;
        width: 15px;
        height: 15px;
        margin-right: 5px;
      }
      .map-button {
        color: #fff;
        background-color: #aaa;
        width: 30px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        border-radius: 30px;
        -webkit-transition: all 250ms;
        transition: all 250ms;
        display: flex;
        align-items: center;
        justify-content: center;
        i {
          color: #fff;
        }
      }
    }

    .row-2 {
      display: flex;
      justify-content: unset;
      gap: 5px;
      align-items: center;
      .image {
        img {
          min-width: 30px;
          max-width: 30px;
        }
      }
    }

    .row-7 {
      i {
        color: #666;
        margin: 0 3px;
      }
    }

    .row-8 {
      justify-content: center;
    }
    .actions {
      display: flex;
      span {
        color: #fff;
        padding: 8px 20px;
        margin-left: 0;
      }
      .notes {
        i {
          color: #fff;
        }
      }
    }

    .clock {
      i {
        color: #F25E0D;
      }
    }

    .pickup {
      i {
        color: #d92626;
      }
    } 

    .dropoff {
      i {
        color: #26D97A;
      }
    }
  }
}
.optin-icon{
  min-width: 18px!important;
  width: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dispatch/ReservationRow.vue